import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { PRIMARY } from "../../../vars/vars";

const trackRelatedItemClick = () => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "related_item",
  });
};

const DetailsRelatedItem = ({
  displayname,
  photos,
  name,
  description,
  price,
}) => (
  <StyledLinkContainer to={"/details/" + name}>
    <RelatedItem onClick={() => trackRelatedItemClick()}>
      <PhotoContainer>
        <Photo
          src={
            photos.length
              ? photos[0].url
              : "https://3cerp.eu/api/file/pedders-logo.png"
          }
          alt={displayname}
        />
      </PhotoContainer>
      <ContentContainer>
        <ProductTitle>
          <ProductName>{name}</ProductName>
          <ProductDescription>{description}</ProductDescription>
        </ProductTitle>
        <Price>
          {price.grossprice} {price.symbol}
        </Price>
      </ContentContainer>
    </RelatedItem>
  </StyledLinkContainer>
);

export default DetailsRelatedItem;

const RelatedItem = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: white;
  transition: all 0.3s ease;
  overflow: hidden;

  &:hover {
    border-color: ${PRIMARY};
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
`;

const PhotoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  min-height: 250px;
`;

const Photo = styled.img`
  max-width: 100%;
  max-height: 210px;
  object-fit: contain;
`;

const ContentContainer = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  text-align: center;
`;

const StyledLinkContainer = styled(Link)`
  text-decoration: none;
  color: inherit;
  display: block;

  &:hover {
    text-decoration: none;
  }
`;

const Price = styled.div`
  font-family: "Open Sans", sans-serif;
  font-weight: 700;
  color: ${PRIMARY};
  font-size: 18px;
  margin-top: auto;
`;

const ProductTitle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin: 0 0 12px 0;
  flex-grow: 1;
`;

const ProductName = styled.h3`
  color: #333;
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 4px 0;
  line-height: 1.3;

  ${RelatedItem}:hover & {
    color: ${PRIMARY};
    text-decoration: underline;
  }
`;

const ProductDescription = styled.span`
  color: #666;
  font-family: "Open Sans", sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.3;
`;
